/* RESPONSIBLE TEAM: team-actions */
const APP_PACKAGE_TABS = {
  description: 'description',
  settings: 'settings',
  onboarding: 'onboarding',
  health: 'health',
};

export { APP_PACKAGE_TABS };
